import React, { useEffect, useState } from "react";
import "./RejectedTransactions.css";
import { NavLink, useNavigate } from "react-router-dom";

const RejectedTransactions = () => {
  const navigate = useNavigate();
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [stats, setStats] = useState({
    rejected: 0,
    totalRejectedAmount: 0,
  });

  

  const fetchRejectedTransactions = async () => {

    try {

      setLoading(true);

      const response = await fetch(
        "/backend/admin/transactions/rejected",
        {
          method: "POST",
          credentials: "include",
        }
      );

      const data = await response.json();

      if (response.ok) {

        const rejectedTransactions = data.rejected || [];

        const totalRejectedAmount =
          rejectedTransactions.reduce(
            (sum, item) =>
              sum + Number(item.amount_paid || 0),
            0
          );

        setTransactions(rejectedTransactions);

        setStats({
          rejected: rejectedTransactions.length,
          totalRejectedAmount,
        });

      } else {

        alert(
          data.error ||
            "Unable to fetch rejected transactions."
        );

      }

    } catch (err) {

      console.error(err);
      alert("Server Error");

    } finally {

      setLoading(false);

    }

  };

  useEffect(() => {
    fetchRejectedTransactions();
  }, []);

 

  const handleLogout = () => {
    navigate("/alumni-login", { replace: true, state: { loggedOut: true } });
  };

  return (
    <div className="admin-dashboard">

     

      <aside className="admin-sidebar">

        <div className="admin-sidebar-header">
          <h2>Admin Panel</h2>
        </div>

        <nav className="admin-sidebar-menu">

          <NavLink
            to="/admin-dashboard"
            className="admin-menu-item"
          >
            Pending Transactions
          </NavLink>

          <NavLink
            to="/approved-transactions"
            className="admin-menu-item"
          >
            Approved Transactions
          </NavLink>

          <NavLink
            to="/rejected-transactions"
            className="admin-menu-item"
          >
            Rejected Transactions
          </NavLink>

          <div className="admin-menu-divider"></div>

          <button
            className="admin-logout-btn"
            onClick={handleLogout}
          >
            Logout
          </button>

        </nav>

      </aside>

      {/* ================= Main ================= */}

      <main className="admin-main">

        <div className="admin-header">

          <h1>Rejected Transactions</h1>

          <p>
            List of all rejected payment transactions.
          </p>

        </div>

        {/* ================= Dashboard Cards ================= */}

        <div className="admin-cards">

          <div className="admin-card">

            <h4>Total Rejected</h4>

            <h2>{stats.rejected}</h2>

          </div>

          <div className="admin-card">

            <h4>Total Rejected Amount</h4>

            <h2>
              ₹ {stats.totalRejectedAmount.toLocaleString()}
            </h2>

          </div>

        </div>

        {/* ================= Table ================= */}

        <div className="admin-table-container">

          <table>

            <thead>

              <tr>

                <th>ID</th>
                <th>Name</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Donor</th>
                <th>Fund</th>
                <th>Installment</th>
                <th>Due Amount</th>
                <th>Amount Paid</th>
                <th>Due Date</th>
                <th>Rejected At</th>
                <th>Reason</th>
                <th>Status</th>

              </tr>

            </thead>

            <tbody>
                              {loading ? (

                <tr>
                  <td colSpan="13" className="admin-center">
                    Loading rejected transactions...
                  </td>
                </tr>

              ) : transactions.length === 0 ? (

                <tr>
                  <td colSpan="13" className="admin-center">
                    No Rejected Transactions Found
                  </td>
                </tr>

              ) : (

                transactions.map((item) => (

                  <tr key={item.id}>

                    <td>{item.id}</td>

                    <td>{item.fullname}</td>

                    <td>{item.email}</td>

                    <td>{item.phone}</td>

                    <td>{item.donor_name}</td>

                    <td>{item.fund_type}</td>

                    <td>#{item.installment_no}</td>

                    <td>
                      ₹ {Number(item.due_amount).toLocaleString()}
                    </td>

                    <td>
                      ₹ {Number(item.amount_paid).toLocaleString()}
                    </td>

                    <td>
                      {item.due_date
                        ? new Date(item.due_date).toLocaleDateString()
                        : "-"}
                    </td>

                    <td>
                      {item.approved_at
                        ? new Date(item.approved_at).toLocaleString()
                        : "-"}
                    </td>

                    <td className="reject-reason">
                      {item.rejection_reason || "-"}
                    </td>

                    <td>

                      <span
                        className={`admin-status ${String(
                          item.approval_status
                        ).toLowerCase()}`}
                      >
                        {item.approval_status}
                      </span>

                    </td>

                  </tr>

                ))

              )}

            </tbody>

          </table>

        </div>

      </main>

    </div>

  );
};

export default RejectedTransactions;
            